import TOGGLE_ACTIVATE from '@/store/modules/develop/types';

export default {
  [TOGGLE_ACTIVATE]: state => {
    state.active = !state.active;
    console.log(`%c🤘😎Develop Mode: ${state.active}`, 'color: #fff; font-size: 14px; border: 1px solid #c44; background: #781a1a; padding: 2px 5px; border-radius: 5px;');
  }
};
